import { useState } from "react"
import React from "react"
import "../../css/MediaPage/presslist.css"

const DateFilter = props => {
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")

  return (
    <div>
      <div className="mt-3 ml-3">
        <a href="/resources/media">
          <i
            className="fa fa-arrow-left"
            style={{ fontSize: "1.5em", color: "#00ABFF" }}
          />
        </a>
      </div>
      <div className="row font-samsung">
        <label htmlFor="startDate">From</label>
        <input
          type="date"
          className="form-control ml-3 mr-3 fromto"
          id="startDate"
          onChange={e => props.getStartDate(e.target.value)}
        />
        <span className="input-group-addon"></span>
        <label id="toDate" htmlFor="endDate">
          To
        </label>
        <input
          type="date"
          className="form-control ml-3 to"
          id="endDate"
          onChange={e => props.getEndDate(e.target.value)}
        />
      </div>
    </div>
  )
}

export default DateFilter
